<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-building"></i>
    </div>
    <div>
      <h2 class="dialog-title">Edit Agency/Customer</h2>
      <p class="dialog-subtitle">Fill in the agency/customer details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="agencyForm" class="dialog-form-grid">
    <!-- Agency -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">Agency <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="agency" placeholder="Enter agency name">
        @if( agencyForm.get('agency')?.hasError('required') ) {
          <mat-error>Agency is required</mat-error>
        }
        @if( agencyForm.get('agency')?.hasError('invalidcharacters') ) {
          <mat-error>Agency contains invalid characters</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Commercial Offices -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">Commercial Offices <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="commercialOffices" placeholder="Select commercial offices" multiple [compareWith]="comparatorService.compareById">
          <mat-select-trigger>
            @if (agencyForm.get('commercialOffices')?.value?.length > 0) {
              {{ agencyForm.get('commercialOffices')?.value[0] | objectdesc}}
              @if (agencyForm.get('commercialOffices')?.value?.length > 1) {
                <span class="additional-selection">
                  (+{{ agencyForm.get('commercialOffices')?.value.length - 1 }}
                  {{ agencyForm.get('commercialOffices')?.value.length === 2 ? 'other' : 'others' }})
                </span>
              }
            }
          </mat-select-trigger>
          @for( office of offices; track office ) {
            <mat-option [value]="office">
              {{ office | objectdesc}}
            </mat-option>
          }
        </mat-select>
        @if( agencyForm.get('commercialOffices')?.hasError('required') ) {
          <mat-error>Commercial Offices is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- External ID -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">External ID</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="externalId" placeholder="Enter external ID">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!agencyForm.valid">
    {{(data.id == -1 ? 'Create' : 'Update')}} Agency/Customer
  </button>
</mat-dialog-actions>
